var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:({padding: _vm.$vuetify.breakpoint.smAndDown ? '0px' : null}),attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('div',{attrs:{"id":"video-container"}},[_c('v-playback',{attrs:{"auto-play":"play","url":_vm.data}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }